/* Phone behaviour shared by the Workshop, History, Team and rider pages (styles: curtis-mobile-pages.css).
   1. Photos sit in black and white and colour up when they reach the middle of the screen, as on the
      homepage. Phones only; without this script every photo simply stays in colour.
   2. Swipe rows ([data-swipe-scope] holding a [data-swipe-row] and a [data-swipe-nav]) get a live
      "2 / 5" count and previous/next buttons that step one photo at a time.
   The snippet that loads this can appear several times on a page, so it only ever runs once. */
(() => {
  if (window.curtisMobilePages) return;
  window.curtisMobilePages = true;

  const phone = window.matchMedia('(max-width: 749px)');
  const still = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const MONO = [
    '.workshop-story-step__media',
    '.workshop-materials__media',
    '.curtis-photo-gallery__item',
    '.curtis-vip-profile__media',
    '.history-timeline__card-media',
    '.history-gallery__item:not([aria-hidden="true"])',
    '.team-index__card-img-wrap',
    '.rider-profile__gallery-item',
  ].join(',');

  let observer = null;

  const watchPhotos = (root = document) => {
    if (!phone.matches) return;
    // A small box in the middle of the screen: whichever photo crosses it is "the one being looked at",
    // both scrolling down the page and swiping along a row.
    observer ??= new IntersectionObserver(
      (entries) => {
        for (const { target, isIntersecting } of entries) target.classList.toggle('is-centred', isIntersecting);
      },
      { rootMargin: '-40% -45% -40% -45%' },
    );
    for (const photo of root.querySelectorAll(MONO)) {
      photo.classList.add('mp-mono');
      observer.observe(photo);
    }
  };

  const unwatchPhotos = () => {
    observer?.disconnect();
    observer = null;
    for (const photo of document.querySelectorAll('.mp-mono')) photo.classList.remove('mp-mono', 'is-centred');
  };

  const setupRow = (scope) => {
    const row = scope.querySelector('[data-swipe-row]');
    const nav = scope.querySelector('[data-swipe-nav]');
    if (!row || !nav || scope.dataset.swipeReady) return;
    scope.dataset.swipeReady = 'true';

    const items = [...row.children];
    const count = nav.querySelector('[data-swipe-count]');
    const [prev, next] = nav.querySelectorAll('[data-swipe-step]');
    if (items.length < 2) {
      nav.hidden = true;
      return;
    }

    const offset = (item) => item.offsetLeft - items[0].offsetLeft;
    const current = () => {
      let best = 0;
      items.forEach((item, i) => {
        if (Math.abs(offset(item) - row.scrollLeft) < Math.abs(offset(items[best]) - row.scrollLeft)) best = i;
      });
      // At the end of the row the last photo can't reach the left edge, so count it once the row is fully scrolled
      if (row.scrollLeft >= row.scrollWidth - row.clientWidth - 2) best = items.length - 1;
      return best;
    };

    let frame = 0;
    const sync = () => {
      frame = 0;
      const index = current();
      if (count) count.textContent = `${index + 1} / ${items.length}`;
      if (prev) prev.disabled = index === 0;
      if (next) next.disabled = index === items.length - 1;
    };

    row.addEventListener('scroll', () => { if (!frame) frame = requestAnimationFrame(sync); }, { passive: true });
    nav.addEventListener('click', (event) => {
      const button = event.target.closest('[data-swipe-step]');
      if (!button) return;
      const target = items[Math.min(items.length - 1, Math.max(0, current() + Number(button.dataset.swipeStep)))];
      row.scrollTo({ left: offset(target), behavior: still() ? 'instant' : 'smooth' });
    });
    sync();
  };

  const init = (root = document) => {
    watchPhotos(root);
    root.querySelectorAll('[data-swipe-scope]').forEach(setupRow);
  };

  phone.addEventListener('change', () => (phone.matches ? watchPhotos() : unwatchPhotos()));
  document.addEventListener('shopify:section:load', (event) => init(event.target));

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }
})();
